import { Check, ChevronDown, X } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { Button } from 'src/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from 'src/components/ui/dropdown-menu';

export const DEFAULT_FIELDS = ['clicks', 'impressions', 'conversions', 'spend', 'cpa', 'cpc', 'cpm', 'ctr'];

interface ClientViewCustomizeWrapperProps {
  key?: string;
  className?: string;
  enabled?: boolean;
  bottom?: boolean;
  children: React.ReactNode;
  fieldSelection?: boolean;
  onStateChange?: (enabled: boolean) => void;
}

const ClientViewCustomizeWrapper: React.FC<ClientViewCustomizeWrapperProps> = ({ children, enabled, onStateChange, fieldSelection = true, key, className, bottom }) => {
  const [enabledState, setEnabledState] = useState(enabled);
  const [fieldSelectionState, setFieldSelectionState] = useState<string[]>([]);

  useEffect(() => {
    return onStateChange?.(enabledState ?? false);
  }, [enabledState]);

  const handleItemClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!enabledState) {
      e.stopPropagation();
      e.preventDefault();
      return false; // Add explicit return false
    }
  };

  const handleFieldSelection = (field: string) => {
    if (fieldSelectionState.includes(field)) {
      setFieldSelectionState(fieldSelectionState.filter((f) => f !== field));
    } else {
      setFieldSelectionState([...fieldSelectionState, field]);
    }
  };

  return (
    <div className={`relative ${className}`}>
      <div className={` flex flex-col gap-2 absolute ${bottom ? 'bottom-2' : 'top-2'} right-2 z-[9999]`}>
        <Button
          className={`text-white ${enabledState ? 'bg-green-501' : 'bg-red-501'} rounded-full`}
          variant='primary'
          size='sm'
          onClick={() => setEnabledState(!enabledState)}
        >
          {enabledState ? <Check className='size-4' /> : <X className='size-4' />}
          {enabledState ? 'Enabled' : 'Disabled'}
        </Button>
        {fieldSelection && enabledState && (
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button
                className='text-black bg-gray-201 rounded-full justify-start'
                variant='primary'
                size='sm'
              >
                <ChevronDown className='size-4' />
                Fields
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent className='z-[9999]'>
              {DEFAULT_FIELDS.map((field) => (
                <DropdownMenuItem
                  key={field}
                  onClick={(e) => {
                    e.preventDefault();
                    handleFieldSelection(field);
                  }}
                  onSelect={(e) => e.preventDefault()}
                  className='flex flex-row items-center justify-between'
                >
                  {field}
                  {(fieldSelectionState.includes(field) || fieldSelectionState.length === 0) && <Check className='size-4' />}
                </DropdownMenuItem>
              ))}
            </DropdownMenuContent>
          </DropdownMenu>
        )}
      </div>
      <div
        className={`${enabledState ? 'opacity-100' : 'opacity-30'} ${!enabledState ? 'pointer-events-none' : ''}`}
        onClick={handleItemClick}
      >
        {children}
      </div>
    </div>
  );
};

export default ClientViewCustomizeWrapper;